export default __webpack_public_path__ + "static/media/a6.a13bb6e5.png";